class Pills {
    constructor() {
        const elements = document.getElementsByClassName('pills__item');
        if (elements) {
            this.bindEvents([...elements]);
        }
    }

    bindEvents(elements) {
        elements.forEach((element) => {
            element.addEventListener('click', (event) => {
                event.currentTarget.parentElement.scrollTo({
                    left: (event.currentTarget.offsetLeft - 30),
                    behavior: "smooth"
                });
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => new Pills());